import React from "react";

import "./login-page.css";

import WhoAmI from "../components/who-am-i";

export default function LoginPage() {
  return (
    <div className="body">
      <WhoAmI />
    </div>
  );
}
